export default [
  {
    path: '/hr/defines/banks',
    name: 'hrBanks',
    component: () => import('@/views/Hr/Defines/Banks/Index.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Bankalar',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/banks/add',
    name: 'hrBanksAdd',
    component: () => import('@/views/Hr/Defines/Banks/Add.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Bankalar',
          to: '/hr/defines/banks',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/banks/edit/:id',
    name: 'hrBanksEdit',
    component: () => import('@/views/Hr/Defines/Banks/Edit.vue'),
    meta: {
      pageTitle: 'Bankalar',
      breadcrumb: [
        {
          text: 'Bankalar',
          to: '/hr/defines/banks',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/blood_group',
    name: 'hrBloodGroup',
    component: () => import('@/views/Hr/Defines/Blood_groups/Index.vue'),
    meta: {
      pageTitle: 'Kan Grupları',
      breadcrumb: [
        {
          text: 'Kan Grupları',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/blood_group/add',
    name: 'hrBloodGroupAdd',
    component: () => import('@/views/Hr/Defines/Blood_groups/Add.vue'),
    meta: {
      pageTitle: 'Kan Grupları',
      breadcrumb: [
        {
          text: 'Kan Grupları',
          to: '/hr/defines/blood_group',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/blood_group/edit/:id',
    name: 'hrBloodGroupEdit',
    component: () => import('@/views/Hr/Defines/Blood_groups/Edit.vue'),
    meta: {
      pageTitle: 'Kan Grupları',
      breadcrumb: [
        {
          text: 'Kan Grupları',
          to: '/hr/defines/blood_group',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/disabilities',
    name: 'hrDisabilities',
    component: () => import('@/views/Hr/Defines/Disabilities/Index.vue'),
    meta: {
      pageTitle: 'Engel Listesi',
      breadcrumb: [
        {
          text: 'Engel Listesi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/disabilities/add',
    name: 'hrDisabilitiesAdd',
    component: () => import('@/views/Hr/Defines/Disabilities/Add.vue'),
    meta: {
      pageTitle: 'Engel Listesi',
      breadcrumb: [
        {
          text: 'Engel Listesi',
          to: '/hr/defines/disabilities',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/disabilities/edit/:id',
    name: 'hrDisabilitiesEdit',
    component: () => import('@/views/Hr/Defines/Disabilities/Edit.vue'),
    meta: {
      pageTitle: 'Engel Listesi',
      breadcrumb: [
        {
          text: 'Engel Listesi',
          to: '/hr/defines/disabilities',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationLevels',
    name: 'hrEducationLevels',
    component: () => import('@/views/Hr/Defines/Education_levels/Index.vue'),
    meta: {
      pageTitle: 'Eğitim Seviyeleri',
      breadcrumb: [
        {
          text: 'Eğitim Seviyeleri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationLevels/add',
    name: 'hrEducationLevelsAdd',
    component: () => import('@/views/Hr/Defines/Education_levels/Add.vue'),
    meta: {
      pageTitle: 'Eğitim Seviyeleri',
      breadcrumb: [
        {
          text: 'Eğitim Seviyesi',
          to: '/hr/defines/educationLevels',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationLevels/edit/:id',
    name: 'hrEducationLevelsEdit',
    component: () => import('@/views/Hr/Defines/Education_levels/Edit.vue'),
    meta: {
      pageTitle: 'Eğitim Seviyeleri',
      breadcrumb: [
        {
          text: 'Eğitim Seviyeleri',
          to: '/hr/defines/educationLevels',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationalStatuses',
    name: 'hrEducationalStatuses',
    component: () => import('@/views/Hr/Defines/Educational_statuses/Index.vue'),
    meta: {
      pageTitle: 'Eğitim Durumları',
      breadcrumb: [
        {
          text: 'Eğitim Durumları',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationalStatuses/add',
    name: 'hrEducationalStatusesAdd',
    component: () => import('@/views/Hr/Defines/Educational_statuses/Add.vue'),
    meta: {
      pageTitle: 'Eğitim Durumları',
      breadcrumb: [
        {
          text: 'Eğitim Durumları',
          to: '/hr/defines/educationalStatuses',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/educationalStatuses/edit/:id',
    name: 'hrEducationalStatusesEdit',
    component: () => import('@/views/Hr/Defines/Educational_statuses/Edit.vue'),
    meta: {
      pageTitle: 'Eğitim Durumları',
      breadcrumb: [
        {
          text: 'Eğitim Durumları',
          to: '/hr/defines/educationalStatuses',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeePaymentTypes',
    name: 'hrEmployeePaymentTypes',
    component: () => import('@/views/Hr/Defines/Employee_payment_types/Index.vue'),
    meta: {
      pageTitle: 'Personel Ödeme Tipleri',
      breadcrumb: [
        {
          text: 'Personel Ödeme Tipleri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeePaymentTypes/add',
    name: 'hrEmployeePaymentTypesAdd',
    component: () => import('@/views/Hr/Defines/Employee_payment_types/Add.vue'),
    meta: {
      pageTitle: 'Personel Ödeme Tipleri',
      breadcrumb: [
        {
          text: 'Personel Ödeme Tipleri',
          to: '/hr/defines/employeePaymentTypes',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeePaymentTypes/edit/:id',
    name: 'hrEmployeePaymentTypesEdit',
    component: () => import('@/views/Hr/Defines/Employee_payment_types/Edit.vue'),
    meta: {
      pageTitle: 'Personel Ödeme Tipleri',
      breadcrumb: [
        {
          text: 'Personel Ödeme Tipleri',
          to: '/hr/defines/employeePaymentTypes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeeTasks',
    name: 'hrEmployeeTasks',
    component: () => import('@/views/Hr/Defines/Employee_tasks/Index.vue'),
    meta: {
      pageTitle: 'Personel Görevleri',
      breadcrumb: [
        {
          text: 'Personel Görevleri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeeTasks/add',
    name: 'hrEmployeeTasksAdd',
    component: () => import('@/views/Hr/Defines/Employee_tasks/Add.vue'),
    meta: {
      pageTitle: 'Personel Görevleri',
      breadcrumb: [
        {
          text: 'Personel Görevleri',
          to: '/hr/defines/employeeTasks',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/employeeTasks/edit/:id',
    name: 'hrEmployeeTasksEdit',
    component: () => import('@/views/Hr/Defines/Employee_tasks/Edit.vue'),
    meta: {
      pageTitle: 'Personel Görevleri',
      breadcrumb: [
        {
          text: 'Personel Görevleri',
          to: '/hr/defines/employeeTasks',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/genders',
    name: 'hrGenders',
    component: () => import('@/views/Hr/Defines/Genders/Index.vue'),
    meta: {
      pageTitle: 'Cinsiyetler',
      breadcrumb: [
        {
          text: 'Cinsiyetler',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/genders/add',
    name: 'hrGendersAdd',
    component: () => import('@/views/Hr/Defines/Genders/Add.vue'),
    meta: {
      pageTitle: 'Cinsiyetler',
      breadcrumb: [
        {
          text: 'Cinsiyetler',
          to: '/hr/defines/genders',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/genders/edit/:id',
    name: 'hrGendersEdit',
    component: () => import('@/views/Hr/Defines/Genders/Edit.vue'),
    meta: {
      pageTitle: 'Cinsiyetler',
      breadcrumb: [
        {
          text: 'Cinsiyetler',
          to: '/hr/defines/genders',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/maritals',
    name: 'hrMaritals',
    component: () => import('@/views/Hr/Defines/Maritals/Index.vue'),
    meta: {
      pageTitle: 'Medeni Durum',
      breadcrumb: [
        {
          text: 'Medeni Durum',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/maritals/add',
    name: 'hrMaritalsAdd',
    component: () => import('@/views/Hr/Defines/Maritals/Add.vue'),
    meta: {
      pageTitle: 'Medeni Durum',
      breadcrumb: [
        {
          text: 'Medeni Durum',
          to: '/hr/defines/maritals',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/maritals/edit/:id',
    name: 'hrMaritalsEdit',
    component: () => import('@/views/Hr/Defines/Maritals/Edit.vue'),
    meta: {
      pageTitle: 'Medeni Durum',
      breadcrumb: [
        {
          text: 'Medeni Durum',
          to: '/hr/defines/maritals',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/permitTypes',
    name: 'hrPermitTypes',
    component: () => import('@/views/Hr/Defines/Permit_types/Index.vue'),
    meta: {
      pageTitle: 'İzin Tipleri',
      breadcrumb: [
        {
          text: 'İzin Tipleri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/permitTypes/add',
    name: 'hrPermitTypesAdd',
    component: () => import('@/views/Hr/Defines/Permit_types/Add.vue'),
    meta: {
      pageTitle: 'İzin Tipleri',
      breadcrumb: [
        {
          text: 'İzin Tipleri',
          to: '/hr/defines/permitTypes',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/permitTypes/edit/:id',
    name: 'hrPermitTypesEdit',
    component: () => import('@/views/Hr/Defines/Permit_types/Edit.vue'),
    meta: {
      pageTitle: 'İzin Tipleri',
      breadcrumb: [
        {
          text: 'İzin Tipleri',
          to: '/hr/defines/permitTypes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/salaryPeriods',
    name: 'hrSalaryPeriods',
    component: () => import('@/views/Hr/Defines/Salary_periods/Index.vue'),
    meta: {
      pageTitle: 'Maaş Dönemleri',
      breadcrumb: [
        {
          text: 'Maaş Dönemleri',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/salaryPeriods/add',
    name: 'hrSalaryPeriodsAdd',
    component: () => import('@/views/Hr/Defines/Salary_periods/Add.vue'),
    meta: {
      pageTitle: 'Maaş Dönemleri',
      breadcrumb: [
        {
          text: 'Maaş Dönemleri',
          to: '/hr/defines/salaryPeriods',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
    },
  },
  {
    path: '/hr/defines/salaryPeriods/edit/:id',
    name: 'hrSalaryPeriodsEdit',
    component: () => import('@/views/Hr/Defines/Salary_periods/Edit.vue'),
    meta: {
      pageTitle: 'Maaş Dönemleri',
      breadcrumb: [
        {
          text: 'Maaş Dönemleri',
          to: '/hr/defines/salaryPeriods',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
    },
  },
]
